import React, { useEffect, useState } from "react";
import { formatNum } from "../../../../oscar-pos-core/constants";
import { UBAppModal, UBInput } from "../../../../Libraries";
import HeaderItem from "./HeaderItem";
import ListItem from "./ListItem";
import { useSnackbar } from "../../../../context/SnackbarContext";
import { analytics, triggerLogEvent } from "../../../../config/firebase";

const EditOrderModal = ({ header, body, footer }) => {
    const {
        toggleUpdateModal: handleClose,
        orderDetail,
        toggle,
        setDisableUpdate,
        setUpdatedItems,
        disableUpdate,
        updatedItems,
        onChangeText,
        note,
        I18n,
    } = body || {};

    const [total, setTotal] = useState(0);
    const { showSnackbar } = useSnackbar();

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (toggle) {
                if (event.key === 'Escape') {
                    // Close the modal when the 'Escape' key is pressed
                    handleClose()
                } else if (event.key === 'Enter' && footer?.length && !footer[1]?.data?.disabled) {
                    footer?.length && footer[1]?.data?.onClick(); // Trigger an action when the 'Enter' key is pressed
                }
            }
        };

        // Add the event listener when the modal is open
        if (toggle) {
            window.addEventListener('keydown', handleKeyDown);
        }

        // Remove the event listener when the component unmounts
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [toggle, footer]);

    useEffect(() => {
        handleMap();
    }, [toggle]);

    useEffect(() => {
        if (toggle) handleTotal();
    }, []);

    /**
     * Create hashmap of orders to update qty
     * @returns hashmap
    */
    const handleMap = () => {
        let items = {};
        orderDetail.map((val) => {
            items[val.id] = { ...val };
        });

        setUpdatedItems(items);
    };

    /**
     * Calculates total of order on quantity change
    */
    const handleTotal = (items) => {
        setTotal(
            Object.values(items || updatedItems).reduce(
                (value, data) => (value += data.allocated_qty * data.discounted_price),
                0
            )
        );
    }

    /**
     * Receive value and id to change the qty of specific order
     * @returns orders 
    */
    const onChangeQty = (value, id) => {
        if (value === "" || /^[0-9\b]+$/.test(value)) {
            setUpdatedItems((prev) => {
                let all = { ...prev };
                if (value > all[id].demanded_qty) showSnackbar({ message: 'Quantity should not be greater than order quantity', severity: 'info', icon: '' });
                else {
                    triggerLogEvent(analytics, "sc_edit_order_item_qty_changed", { item_id: id, quantity: value });
                    all[id].allocated_qty = value.replace(/[^0-9.]|(?<=\..*)\./g, "");
                    if (disableUpdate) setDisableUpdate(false);
                    handleTotal(all);
                }
                return all;
            });
        }
    };

    return (
        <UBAppModal
            id="edit_order_modal"
            open={toggle}
            header={{
                handleClose: () => handleClose(),
                dont_show_cross_icon: true,
                title: header?.title
            }}
            footer={footer}
        >
            <HeaderItem I18n={I18n} />
            <div className="editOrderModalList">
                {orderDetail.map((item, index) => {
                    return (
                        <ListItem
                            updatedItems={updatedItems}
                            onChangeQty={onChangeQty}
                            key={index}
                            item={item}
                            I18n={I18n}
                        />
                    );
                })}

                <div className="totalValueBox">
                    <p className="fontSize14 fontWeight600 darkGrayColor"> Total value</p>
                    <p className="fontSize14 fontWeight600 darkGrayColor">
                        Rs. {formatNum(total)}
                    </p>
                </div>
            </div>

            <UBInput
                inputId="edit_order_note_input"
                label={I18n.add_note_to_the_order}
                onChange={onChangeText}
                value={note}
                name={I18n.add_note_to_the_order}
            />
        </UBAppModal>
    );
};

export default EditOrderModal;
